NtechApp.DashboardCover = function($view) {
    var me = this;

    this._$view = null;
    this._baseDashboardCover = null;

    this._construct = function() {
        me._$view = $view;
        me._baseDashboardCover = new NtechApp.BaseDashboardCover(
            me._$view, {
                saveAvatarRoute: "business_dashboard_save_avatar",
                saveCoverRoute: "business_dashboard_save_cover",
                rmAvatarRoute: "business_dashboard_delete_avatar",
                rmCoverRoute: "business_dashboard_delete_cover"
            }
        );

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.DashboardCover, {
});